import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '../features/parent/OverviewPage';
import { RequireAuth, STATS_ROLES } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/')({
  component: () => <RequireAuth role={STATS_ROLES}>{(me) => <OverviewPage me={me} />}</RequireAuth>,
});
